import { DifferenceModel } from 'src/Elements/Dashboard/HistoryValuesModel'
import { stringWithSIPrefix } from 'src/Libs/system-data-handler/utils/formatNumberWithSIPrefix'
import { UnitTypes } from 'src/Libs/types'

interface ReturnType {
  productionWithUnit: string
  networkWithUnit: string
  co2WithUnit: string
}

export const calculateProductionWithUnit = (dcPower: number | undefined, powermeterProductionValue: number): string =>
  stringWithSIPrefix((dcPower ?? 0) + powermeterProductionValue, UnitTypes.wattHour, 1)

export const calculateNetworkWithUnit = (netIn: number | undefined): string => stringWithSIPrefix(netIn ?? 0, UnitTypes.wattHour, 1)

export const calculateCo2WithUnit = (co2Savings: number): string => {
  const co2InTons = co2Savings / 1e6 >= 1
  const value = co2InTons ? Math.round(co2Savings / 1e6) : Math.abs(Math.round((co2Savings / 1e3) * 100) / 100)

  return stringWithSIPrefix(value, co2InTons ? UnitTypes.ton : UnitTypes.kilogram, undefined, 0)
}
/**
 * Calculates summary data regarding production, network and co2 savings.
 *
 * @param co2Savings
 * @param powermeterProductionValue
 * @param differences
 * @returns
 */
export const calculateSummaryData = (co2Savings: number, powermeterProductionValue: number, differences?: DifferenceModel): ReturnType => {
  const productionWithUnit = calculateProductionWithUnit(differences?.diff?.DC_Power, powermeterProductionValue)
  const networkWithUnit = calculateNetworkWithUnit(differences?.diff?.NetIn)
  const co2WithUnit = calculateCo2WithUnit(co2Savings)

  return { productionWithUnit, networkWithUnit, co2WithUnit }
}
